import { DatePipe } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
import { BillItemSettingComponent } from 'src/app/demo/components/billing/accounting/family/bill-item-setting/bill-item-setting.component';
import { BillingItemSettingsDTO } from 'src/app/demo/model/BillingItemSettingsDTO';
import { InvoiceDTO } from 'src/app/demo/model/InvoiceDTO';
import { InvoiceDetailsDTO } from 'src/app/demo/model/InvoiceDetailsDTO';
import { LedgerAccountDTO } from 'src/app/demo/model/LedgerAccountDTO';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { Common } from 'src/app/demo/utils/common';

@Component({
    selector: 'app-edit-invoice',
    templateUrl: './edit-invoice.component.html',
    styleUrls: ['./edit-invoice.component.scss'],
})
export class EditInvoiceComponent implements OnInit {
    invoiceData: DynamicDialogConfig<any>;
    selectedStudentList: any;
    invoiceForm!: FormGroup;
    invoiceItemForm!: FormGroup;
    optionalDateControl: boolean = false;
    submitButton: boolean = true;
    presetItemList: BillingItemSettingsDTO[] = [];
    discountItemList: BillingItemSettingsDTO[] = [];
    search: any = {};
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 100,
        totalItems: 0,
        sort: 'id,desc',
    };
    // ## start of logic
    // Returns initials from full name
    public getInitials(fullName: string): string {
        if (!fullName) return '';
        const names = fullName.trim().split(' ');
        if (names.length === 1) return names[0].charAt(0).toUpperCase();
        return (
            names[0].charAt(0).toUpperCase() +
            names[names.length - 1].charAt(0).toUpperCase()
        );
    }

    // Returns a background color based on student id
    public getProfileBgColor(id: any): string {
        const colors = [
            '#F44336',
            '#E91E63',
            '#9C27B0',
            '#3F51B5',
            '#03A9F4',
            '#009688',
            '#4CAF50',
            '#FF9800',
            '#795548',
            '#607D8B',
        ];
        let idx = 0;
        if (id) {
            const str = id.toString();
            for (let i = 0; i < str.length; i++) {
                idx += str.charCodeAt(i);
            }
        }
        return colors[idx % colors.length];
    }
    // ## end of logic
    roomList!: RoomDTO[];
    subsidyItemList: LedgerAccountDTO[] = [];
    invoiceObj: any;
    buttonType: string = '';
    currencySignList: any[] = [
        { name: '%', id: '%' },
        { name: '$', id: '$' },
    ];
    invoiceTypeList: any[] = [
        { name: 'New Item', id: 'newItem' },
        { name: 'Preset Item', id: 'presetItem' },
        { name: 'Discount', id: 'discount' },
        { name: 'Subsidy', id: 'subsidy' },
    ];

    minimumInvoiceAmount: number = 0;
    balanceAmount: number = 0;
    originalInvoiceAmount: number = 0;

    // row wise Item Display
    getInvoiceTypeOptions(rowIndex: number): any[] {
        if (rowIndex === 0) {
            // Only first two items for first row
            return this.invoiceTypeList.filter(
                (item) => item.id === 'newItem' || item.id === 'presetItem'
            );
        } else {
            // All items for other rows
            return this.invoiceTypeList;
        }
    }
    userdata: any;

    constructor(
        public config: DynamicDialogConfig,
        private formBuilder: FormBuilder,
        public dialogService: DialogService,
        public ref: DynamicDialogRef,
        private lookupService: LookupService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
        private operationService: OperationService,
        private datePipe: DatePipe,
        private storage: WebStorage
    ) {
        this.invoiceData = this.config;
        this.selectedStudentList = this.invoiceData.data.studentList;
        this.invoiceObj = this.invoiceData.data.invoiceObj;

        // console.log(this.selectedStudentList); //edited
        this.minimumInvoiceAmount = this.invoiceData.data.balanceAmount ;
        // console.log("balance",this.minimumInvoiceAmount);
    }

    // row wise Item Display
    // getInvoiceTypeOptions(rowIndex: number): any[] {
    //     if (rowIndex === 0) {
    //         // Only first two items for first row
    //         return (this.invoiceTypeList || []).filter((item: any) => item.id === 'newItem' || item.id === 'presetItem');
    //     } else {
    //         // All items for other rows
    //         return this.invoiceTypeList || [];
    //     }
    // }

    ngOnInit() {
        this.userdata = this.storage.getUserData();
        this.invoiceForm = this.formBuilder.group({
            id: undefined,
            studentId: undefined,
            date: undefined,
            dueDate: [undefined, [Validators.required]],
            startDate: undefined,
            endDate: undefined,
            invoiceAmount: undefined,
            balanceAmount: undefined,
            invoiceStatus: undefined,
            description: undefined,
            note: undefined,
            status: 'A',
            lastModified: undefined,
            lastModifiedBy: undefined,
            schoolId: this.userdata.schoolId,
            recurringPlanId: undefined,
            invoiceNumber: undefined,
        });

        this.invoiceForm
            .get('startDate')
            ?.valueChanges.subscribe((startDate) => {
                const endDateControl = this.invoiceForm.get('endDate');
                endDateControl?.clearValidators();
                if (startDate) {
                    endDateControl?.setValidators([Validators.required]);
                    this.optionalDateControl = true;
                } else {
                    this.optionalDateControl = false;
                    endDateControl?.reset();
                }
                endDateControl?.updateValueAndValidity();
            });

        this.invoiceItemForm = this.formBuilder.group({
            dynamicArray: this.formBuilder.array([]),
        });

        this.queryBillItemSetting();
        this.querySubsidy();
        this.queryRooms();

        if (this.invoiceData.data.invoiceObj.id != undefined) {
            this.invoiceForm.patchValue({
                id: this.invoiceObj.id,
                studentId: this.invoiceObj.studentId,
                date:
                    this.invoiceObj.date != undefined
                        ? this.formatDateForInput(this.invoiceObj.date)
                        : undefined,
                dueDate:
                    this.invoiceObj.dueDate != undefined
                        ? this.formatDateForInput(this.invoiceObj.dueDate)
                        : undefined,
                startDate:
                    this.invoiceObj.startDate != undefined
                        ? this.formatDateForInput(this.invoiceObj.startDate)
                        : undefined,
                endDate:
                    this.invoiceObj.endDate != undefined
                        ? this.formatDateForInput(this.invoiceObj.endDate)
                        : undefined,
                invoiceAmount: this.invoiceObj.invoiceAmount,
                balanceAmount: this.invoiceObj.balanceAmount,
                invoiceStatus: this.invoiceObj.invoiceStatus,
                description: this.invoiceObj.description,
                note: this.invoiceObj.note,
                status: this.invoiceObj.status,
                lastModified: undefined,
                lastModifiedBy: undefined,
                schoolId: this.invoiceObj.schoolId,
                recurringPlanId: this.invoiceObj.recurringPlanId,
                invoiceNumber: this.invoiceObj.invoiceNumber,
            });

            // const dummyInvoiceItems = this.invoiceObj.dummyInvoiceItems.sort(
            //     (a: any, b: any) => a.id - b.id
            // );
            setTimeout(() => {
                if (this.invoiceObj.dummyInvoiceItems && this.invoiceObj.dummyInvoiceItems.length > 0) {
                    this.initializeFormArray(this.invoiceObj.dummyInvoiceItems);
                } else {
                    console.warn('No invoice items found for invoice ID:', this.invoiceObj.id);
                }
            }, 200);
        }
        this.updateProfileImages(); // ## added this
                // Store the balance and original invoice amount
        this.balanceAmount = this.invoiceData.data.balanceAmount || 0;
        this.originalInvoiceAmount = this.invoiceData.data.invoiceObj?.invoiceAmount || 0;
        
        // Calculate minimum invoice amount
        this.minimumInvoiceAmount = this.balanceAmount;
        
        // console.log("Balance Amount:", this.balanceAmount);
        // console.log("Original Invoice Amount:", this.originalInvoiceAmount);
        // console.log("Minimum Invoice Amount:", this.minimumInvoiceAmount);
    }
    // ## start of logic
    //profile image update function
    updateProfileImages() {
        this.selectedStudentList.forEach((student: any) => {
            if (student.photoUuid) {
                this.lookupService
                    .queryDocumentByPhotoUid(student.photoUuid)
                    .subscribe(
                        (response: HttpResponse<Blob>) => {
                            const body = response?.body;
                            if (body) {
                                const url = this.createImgFromBuffer(body);
                                student.profileimg = url;
                            } else {
                                student.profileimg = undefined;
                            }
                        },
                        () => {
                            student.profileimg = undefined;
                        }
                    );
            } else {
                student.profileimg = undefined;
            }
        });
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }
    // ## end of logic

    get dynamicArray(): FormArray {
        return this.invoiceItemForm.get('dynamicArray') as FormArray;
    }

    addMoreFormGroup() {
        const newFormGroup = this.formBuilder.group({
            id: undefined,
            type: 'newItem',
            description: [undefined, [Validators.required]],
            amount: [undefined, [Validators.required]],
            deductionAmt: null,
            currencySign: undefined,
            percentageAmt: undefined,
            refTable: 'Invoice',
            refTableId: undefined,
            schoolId: undefined,
            status: 'A',
        });
        
        const currentIndex = this.dynamicArray.length;
        this.dynamicArray.push(newFormGroup);

        // Add specific value change listeners for discount/subsidy calculations
        newFormGroup.get('deductionAmt')?.valueChanges.subscribe(() => {
            if (newFormGroup.get('currencySign')?.value === '%') {
                this.onPercentageAmtChange(currentIndex, {});
            } else if (newFormGroup.get('currencySign')?.value === '$') {
                this.onDeductionAmtChange(currentIndex, {});
            }
        });

        newFormGroup.get('percentageAmt')?.valueChanges.subscribe(() => {
            if (newFormGroup.get('currencySign')?.value === '%') {
                this.onPercentageAmtChange(currentIndex, {});
            }
        });

        newFormGroup.get('currencySign')?.valueChanges.subscribe(() => {
            const currencySign = newFormGroup.get('currencySign')?.value;
            
            if (currencySign === '%') {
                // When switching to percentage, make percentageAmt required
                newFormGroup.get('percentageAmt')?.setValidators([Validators.required]);
                newFormGroup.get('percentageAmt')?.updateValueAndValidity();
                this.onPercentageAmtChange(currentIndex, {});
            } else if (currencySign === '$') {
                // When switching to dollar, remove percentage requirement
                newFormGroup.get('percentageAmt')?.clearValidators();
                newFormGroup.get('percentageAmt')?.updateValueAndValidity();
                newFormGroup.get('percentageAmt')?.setValue(null);
                this.onDeductionAmtChange(currentIndex, {});
            }
        });
    }



    initializeFormArray(dummyInvoiceItems: InvoiceDetailsDTO[]) {
        const formArray = this.dynamicArray as FormArray;

        dummyInvoiceItems.forEach((element: InvoiceDetailsDTO, index: number) => {
            const formGroup = this.formBuilder.group({
                id: element?.id,
                type: element.type,
                description: [element.description, Validators.required],
                amount: [element.amount, Validators.required],
                deductionAmt: element.deductionAmt,
                currencySign: element.currencySign,
                percentageAmt: element.percentageAmt,
                refTable: element.refTable,
                refTableId: element.refTableId,
                schoolId: element.schoolId,
                status: element.status,
                sequence: element.sequence,
            });

            // Add value change listeners for discount/subsidy calculations
            this.addValueChangeListeners(formGroup, index);
            formArray.push(formGroup);
        });
    }

    // Helper method to add value change listeners to form groups
    private addValueChangeListeners(formGroup: FormGroup, index: number) {
        formGroup.get('deductionAmt')?.valueChanges.subscribe(() => {
            if (formGroup.get('currencySign')?.value === '%') {
                this.onPercentageAmtChange(index, {});
            } else if (formGroup.get('currencySign')?.value === '$') {
                this.onDeductionAmtChange(index, {});
            }
        });

        formGroup.get('percentageAmt')?.valueChanges.subscribe(() => {
            if (formGroup.get('currencySign')?.value === '%') {
                this.onPercentageAmtChange(index, {});
            }
        });

        formGroup.get('currencySign')?.valueChanges.subscribe(() => {
            const currencySign = formGroup.get('currencySign')?.value;
            
            if (currencySign === '%') {
                // When switching to percentage, make percentageAmt required
                formGroup.get('percentageAmt')?.setValidators([Validators.required]);
                formGroup.get('percentageAmt')?.updateValueAndValidity();
                this.onPercentageAmtChange(index, {});
            } else if (currencySign === '$') {
                // When switching to dollar, remove percentage requirement
                formGroup.get('percentageAmt')?.clearValidators();
                formGroup.get('percentageAmt')?.updateValueAndValidity();
                formGroup.get('percentageAmt')?.setValue(null);
                this.onDeductionAmtChange(index, {});
            }
        });
    }

    async onSubmit(type: string) {
        this.buttonType = type;

        //  if (!this.invoiceForm.valid || !this.invoiceItemForm.valid) {
        //     this.messageService.add({
        //         severity: 'error',
        //         life: 3000,
        //         summary: 'Validation Error',
        //         detail: 'Please fill all required fields correctly.',
        //     });
        //     return;
        // }

         if (!this.isFormValid()) {
            this.messageService.add({
                severity: 'error',
                life: 3000,
                summary: 'Validation Error',
                detail: this.invoiceForm.errors?.['invalidAmount'] 
                    ? this.getAmountValidationMessage() 
                    : 'Please fill all required fields correctly.',
            });
            return;
        }


        const totalAmount = this.getTotalAmount();
        
        // if (this.minimumInvoiceAmount > 0 && totalAmount < this.minimumInvoiceAmount) {
        //     this.messageService.add({
        //         severity: 'error',
        //         life: 3000,
        //         summary: 'Validation Error',
        //         detail: this.getAmountValidationMessage(),
        //     });
        //     return;
        // }
        this.submitButton = false;
        const invoiceItemDetailsObj: InvoiceDetailsDTO[] =
            this.invoiceItemForm.get('dynamicArray')?.value;
        const observables = this.selectedStudentList.map(async (stud: any) => {
            try {
                let invoiceObj: InvoiceDTO = { ...this.invoiceForm.value };
                invoiceObj.invoiceStatus = type === 'save' ? 'Created' : 'Sent';
                if (this.invoiceForm.get('invoiceStatus')?.value == 'Sent') {
                    invoiceObj.invoiceStatus = 'Sent';
                }
                invoiceObj.studentId = stud.id;
                invoiceObj.schoolId = stud.schoolId;
                // invoiceObj.balanceAmount =
                //     this.invoiceForm.get('invoiceAmount')?.value;

                // Calculate updated balance amount
                const originalInvoiceAmount = this.invoiceObj.invoiceAmount || 0;
                const originalBalanceAmount = this.invoiceObj.balanceAmount || 0;
                const updatedInvoiceAmount = this.invoiceForm.get('invoiceAmount')?.value || 0;
                const amountDifference = originalInvoiceAmount - updatedInvoiceAmount;

                invoiceObj.balanceAmount = originalBalanceAmount - amountDifference;

                invoiceObj.dueDate =
                    this.invoiceForm.get('dueDate')?.value != undefined
                        ? Common.convertLocalDateToUTC(
                              this.invoiceForm.get('dueDate')?.value
                          )
                        : undefined;
                invoiceObj.sentDate =
                    invoiceObj.invoiceStatus == 'Sent'
                        ? Common.momentCurrentDate()
                        : undefined;
                invoiceObj.date =
                    this.invoiceForm.get('date')?.value != undefined
                        ? Common.convertLocalDateToUTC(
                              this.invoiceForm.get('date')?.value
                          )
                        : Common.convertLocalDateToUTC(
                              this.datePipe.transform(
                                  new Date(),
                                  'yyyy-MM-dd'
                              ) || Common.momentCurrentDate()
                          );
                invoiceObj.startDate =
                    this.invoiceForm.get('startDate')?.value != undefined
                        ? Common.convertLocalDateToUTC(
                              this.invoiceForm.get('startDate')?.value
                          )
                        : undefined;
                invoiceObj.endDate =
                    this.invoiceForm.get('endDate')?.value != undefined
                        ? Common.convertLocalDateToUTC(
                              this.invoiceForm.get('endDate')?.value
                          )
                        : undefined;

                const res: HttpResponse<InvoiceDTO> | undefined =
                    await this.operationService
                        .updateInvoice(invoiceObj)
                        .toPromise();

                if (res && res.body) {
                    const itemObservables = invoiceItemDetailsObj.map(
                        async (item, index: number) => {
                            if (item.id != undefined) {
                                // Update existing item
                                const itemRes:
                                    | HttpResponse<InvoiceDetailsDTO>
                                    | undefined = await this.operationService
                                    .updateInvoiceItemDetails(item)
                                    .toPromise();
                                return itemRes;
                            } else {
                                // Create new item
                                item.refTableId = res.body?.id;
                                item.sequence = item.sequence
                                    ? item.sequence
                                    : index.toString();
                                const itemRes:
                                    | HttpResponse<InvoiceDetailsDTO>
                                    | undefined = await this.operationService
                                    .createInvoiceItemDetails(item)
                                    .toPromise();
                                return itemRes;
                            }
                        }
                    );

                    await Promise.all(itemObservables); // Wait for all itemObservables to complete

                    if (res.body.invoiceStatus == 'Sent') {
                        await this.operationService
                            .sendInvoice(res.body)
                            .toPromise();
                    }
                }
            } catch (error: any) {
                this.buttonType = '';
                this.messageService.add({
                    severity: 'error',
                    life: 3000,
                    summary: error.error?.title || 'Error',
                    detail: error.error?.detail || 'An error occurred',
                });
            }
        });

        await Promise.all(observables); // Wait for all observables to complete

        let message = {};

        if (this.invoiceData.data.editInvoice == true) {
            this.buttonType = '';
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Invoice Updated Successfully.`,
                life: 3000,
            });
        } else {
            message = {
                severity: 'success',
                summary: 'Success',
                detail: `Invoice Updated Successfully.`,
                life: 3000,
            };
        }

        this.submitButton = true;

        setTimeout(() => {
            if (this.invoiceData.data.editInvoice == true) {
                this.ref.close();
            } else {
                this.ref.close(message);
            }
        }, 1000);
    }

    queryBillItemSetting() {
        this.lookupService
            .queryBillingItemSetting({
                'schoolId.equals': this.userdata.schoolId,
                'status.equals': 'A',
            })
            .subscribe((res: HttpResponse<BillingItemSettingsDTO[]>) => {
                const presetItemList: BillingItemSettingsDTO[] = [];
                const discountItemList: BillingItemSettingsDTO[] = [];

                (res.body || []).forEach((item) => {
                    if (item.isPresetItem === true) {
                        presetItemList.push(item);
                    } else {
                        discountItemList.push(item);
                    }
                });

                this.presetItemList = presetItemList;
                this.discountItemList = discountItemList;
            });
    }

    querySubsidy() {
        const queryParams = {
            'isSubsidy.equals': true,
            'status.equals': 'A',
        };
        this.lookupService
            .queryLedgerAccount(queryParams)
            .subscribe((res: HttpResponse<LedgerAccountDTO[]>) => {
                let temp: LedgerAccountDTO[] = [];
                this.subsidyItemList = res.body ? res.body : temp;
            });
    }

    queryRooms() {
        this.search.size = 500; //this.pageContext.itemsPerPage
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['status.equals'] = 'A';
        this.search['schoolId.equals'] = this.userdata.schoolId;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                let activeRooms: any = res.body?.filter(
                    (each) => each.status == 'A'
                );
                this.roomList = activeRooms ? activeRooms : temp;
            });
    }

    changePresetItem(index: number, e: any) {
        const selectedPreset = e.value;
        const selectedPresetObj = this.presetItemList.find(
            (item: BillingItemSettingsDTO) =>
                item.name === selectedPreset && item.isPresetItem == true
        );
        const formGroup = this.dynamicArray.at(index) as FormGroup;
        if (selectedPreset != undefined) {
            const rate = Number(selectedPresetObj?.rate);
            formGroup.get('amount')?.setValue(rate);
        } else if (selectedPreset == undefined) {
            formGroup.get('amount')?.setValue(null);
        }
    }
    onCurrencyChange(index: number, currency: string, e: any) {
        const formGroup = this.dynamicArray.at(index) as FormGroup;
        const selectedValue = e.target.value;
        
        if (selectedValue === '$') {
            // For dollar amounts, set the amount directly from deductionAmt
            this.onDeductionAmtChange(index, e);
        } else if (selectedValue === '%') {
            // For percentage, trigger percentage calculation
            this.onPercentageAmtChange(index, e);
        }
    }
    onPercentageAmtChange(index: number, e: any) {
        const formGroup = this.dynamicArray.at(index) as FormGroup;
        
        const percentage = parseFloat(formGroup.value.deductionAmt) || 0;
        const baseAmount = parseFloat(formGroup.value.percentageAmt) || 0;
        
        if (percentage > 0 && baseAmount > 0) {
            // Calculate the discount amount: (baseAmount * percentage) / 100
            const discountAmount = (baseAmount * percentage) / 100;
            formGroup.get('amount')?.setValue(discountAmount);
        } else {
            formGroup.get('amount')?.setValue(0);
        }
    }
    onDeductionAmtChange(index: number, e: any) {
        const formGroup = this.dynamicArray.at(index) as FormGroup;
        const deductionValue = parseFloat(formGroup.value.deductionAmt) || 0;
        
        if (formGroup.value.currencySign === '$') {
            // For dollar amounts, set directly as the discount amount
            formGroup.get('amount')?.setValue(deductionValue);
        } else if (formGroup.value.currencySign === '%') {
            // For percentage, trigger percentage calculation
            this.onPercentageAmtChange(index, e);
        } else {
            formGroup.get('amount')?.setValue(0);
        }
    }

    onTypeChange(event: any, index: number) {
        const selectedType = event.target.value;
        const formGroup = this.dynamicArray.at(index) as FormGroup;
        // Clear previous values
        formGroup.get('description')?.reset();
        formGroup.get('amount')?.reset();

        // Update controls based on the selected type
        if (selectedType === 'newItem') {
            formGroup.get('description')?.enable();
            formGroup.get('amount')?.enable();
            formGroup.get('amount')?.setValue(null);
        } else if (selectedType === 'presetItem') {
            formGroup.get('description')?.enable();
            formGroup.get('amount')?.enable();
            formGroup.get('amount')?.setValue(null);
        } else if (selectedType === 'discount') {
            formGroup.get('deductionAmt ')?.enable();
            formGroup.get('currencySign')?.enable();
            formGroup.get('description')?.enable();
            formGroup.get('amount')?.enable();
        } else if (selectedType === 'subsidy') {
            formGroup.get('deductionAmt ')?.enable();
            formGroup.get('currencySign')?.enable();
            formGroup.get('description')?.enable();
            formGroup.get('amount')?.enable();
        }
    }

    getTotalAmount() {
        const formGroup = this.dynamicArray as FormArray;
        const itemDetailsArray = formGroup.value;

        const addAmount = itemDetailsArray
            .filter((item: any) =>
                ['newItem', 'presetItem'].includes(item.type)
            )
            .reduce(
                (total: any, item: any) => total + (Number(item.amount) || 0),
                0
            );

        const minusAmount = itemDetailsArray
            .filter((item: any) => ['discount', 'subsidy'].includes(item.type))
            .reduce(
                (total: any, item: any) => total + (Number(item.amount) || 0),
                0
            );

        const totalAmount = Number((addAmount - minusAmount).toFixed(2));
        this.invoiceForm.get('invoiceAmount')?.setValue(totalAmount);

        this.validateInvoiceAmount(totalAmount);
        return totalAmount;
    }

    validateInvoiceAmount(totalAmount: number): void {
        const paidAmount = this.originalInvoiceAmount - this.balanceAmount;
        
        // If balance is 0 (fully paid), don't allow any changes
        if (this.balanceAmount === 0) {
            this.invoiceForm.setErrors({ invalidAmount: true, fullyPaid: true });
            return;
        }
        
        // If balance equals original amount (nothing paid yet)
        if (this.balanceAmount === this.originalInvoiceAmount) {
            // Allow any amount from 0.01 to any amount above (no upper limit)
            if (totalAmount < 0.01) {
                this.invoiceForm.setErrors({ invalidAmount: true });
            } else {
                // Clear the invalidAmount error only
                const errors = this.invoiceForm.errors;
                if (errors && errors['invalidAmount']) {
                    delete errors['invalidAmount'];
                    this.invoiceForm.setErrors(Object.keys(errors).length > 0 ? errors : null);
                }
            }
        } else {
            // Some amount has been paid
            const minimumAllowed = paidAmount;
            
            // Allow minimum of paid amount to any amount above (no upper limit)
            if (totalAmount < minimumAllowed) {
                this.invoiceForm.setErrors({ invalidAmount: true });
            } else {
                // Clear the invalidAmount error only
                const errors = this.invoiceForm.errors;
                if (errors && errors['invalidAmount']) {
                    delete errors['invalidAmount'];
                    this.invoiceForm.setErrors(Object.keys(errors).length > 0 ? errors : null);
                }
            }
        }
    }


    getAmountValidationMessage(): string {
        const paidAmount = this.originalInvoiceAmount - this.balanceAmount;
        const maxReduction = this.balanceAmount;
        
        // Check if invoice is fully paid
        if (this.balanceAmount === 0) {
            return `This invoice has been fully paid ($${this.originalInvoiceAmount.toFixed(2)}). No changes allowed.`;
        }
        
        if (this.balanceAmount === this.originalInvoiceAmount) {
            // Nothing has been paid yet
            return `Please enter an amount greater than $0.00.`;
        } else {
            // Some amount has been paid
            return `Amount can be reduced by $${maxReduction.toFixed(2)} (current balance). Minimum allowed: $${paidAmount.toFixed(2)}`;
        }
    }

  
    isFormValid(): boolean {
        const totalAmount = this.getTotalAmount();
        const paidAmount = this.originalInvoiceAmount - this.balanceAmount;
        
        // If balance is 0, invoice is fully paid - don't allow any changes
        if (this.balanceAmount === 0) {
            return false;
        }
        
        // Check if form controls are valid (excluding our custom invalidAmount error)
        const formErrors = this.invoiceForm.errors;
        const hasOtherErrors = formErrors && Object.keys(formErrors).filter(key => key !== 'invalidAmount' && key !== 'fullyPaid').length > 0;
        
        if (hasOtherErrors || !this.invoiceItemForm.valid) {
            return false;
        }
        
        // Check if all required fields have values
        if (!this.invoiceForm.get('dueDate')?.value) {
            return false;
        }

        // Check amount validation
        if (this.balanceAmount === this.originalInvoiceAmount) {
            // Nothing paid yet - allow 0.01 and above (no upper limit)
            return totalAmount >= 0.01;
        } else {
            // Some amount paid - must be greater than or equal to paid amount (no upper limit)
            return totalAmount >= paidAmount;
        }
    }

        onItemSetting(header: string) {
        let tempData: any = {};
        this.ref = this.dialogService.open(BillItemSettingComponent, {
            data: tempData,
            header: header,
            width: '40%',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
        });
        this.ref.onClose.subscribe((res) => {
            this.queryBillItemSetting();
        });
    }

    deleteItem(event: Event, item: any, i: number) {
        this.confirmationService.confirm({
            key: 'confirm1',
            target: event.target as EventTarget,
            message: 'Do you want to Delete this Invoice Item?',
            accept: () => this.deleteInvoiceItem(item, i),
            reject: () => {},
        });
    }

    deleteInvoiceItem(item: any, index: number) {
        // Log description and id from FormGroup value
        // console.log(
        //     'Delete Invoice Item - Description:',
        //     item.value.description,
        //     'ID:',
        //     item.value.id
        // );
        if (item.value.id != undefined) {
            this.operationService
                .deleteInvoiceItemDetails(item.value) // passing here the Description and ID from FormGroup value
                .subscribe((res: HttpResponse<InvoiceDetailsDTO>) => {
                    const obj = res.body;
                });
        }
        this.dynamicArray.removeAt(index);
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Invoice Item Deleted successfully.`,
            life: 3000,
        });
    }

    formatDateForInput(date: any): string {
        // console.log("actual date",date);
        // this.datePipe.transform(date, 'yyyy-MM-dd') || '';
        return Common.formatUtcDateForInput(date);
    }


    // Helper method to format discount/subsidy display values
    getDiscountDisplayValue(index: number, type: string): string {
        const formGroup = this.dynamicArray.at(index) as FormGroup;
        const amount = formGroup.get('amount')?.value || 0;
        const displayAmount = Math.abs(Number(amount));
        return displayAmount.toFixed(2);
    }

    // Helper method to check if should show negative sign
    shouldShowNegativeSign(index: number, type: string): boolean {
        const formGroup = this.dynamicArray.at(index) as FormGroup;
        const amount = formGroup.get('amount')?.value;
        return amount != null && amount > 0;
    }
}
